import React from 'react';
import { observer } from 'mobx-react-lite';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const Banner = observer(function Banner({ store }) {
  if (!store.showBanner) {
    return null;
  }

  return (
    <div className="rer-bg-dark-blue pt-3">
      <div className="alert-banner-container py-2 px-4">
        <div className="m-auto flex-centered">
          <p>
            {store.bannerText}{' '}
            <a href={store.url} className="banner-url">
              {store.urlText}
            </a>
          </p>
          <a
            href="#"
            aria-label="Close Banner"
            onClick={store.closeBanner}
            className="banner-close"
          >
            <FontAwesomeIcon icon={['far', 'times-circle']} />
          </a>
        </div>
      </div>
    </div>
  );
});

export default Banner;
